module.exports = __webpack_public_path__ + "static/media/arrow_back_ios-24px.96e99f80.svg";